import { render } from "./MonoModal.vue?vue&type=template&id=01b7fe2e&scoped=true"
import script from "./MonoModal.vue?vue&type=script&lang=js"
export * from "./MonoModal.vue?vue&type=script&lang=js"

import "./MonoModal.vue?vue&type=style&index=0&id=01b7fe2e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b7fe2e"]])

export default __exports__